// hooks/useDeepLinking.js
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useDeepLinking = ({
  loading,
  sampleOrders,
  accounts,
  onRequestSelect,
  onAccountSelect,
  onTabChange,
}) => {
  const location = useLocation();
  const [deepLinkHandled, setDeepLinkHandled] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (deepLinkHandled) return;

    const search = location.search || "";
    if (!search) return;

    const params = new URLSearchParams(search);
    const viewParam = params.get("view");
    const requestIdParam = params.get("requestId");
    const accountIdParam = params.get("accountId");

    if (viewParam && !requestIdParam && !accountIdParam) {
      const allowedViews = ["create", "kanban", "calendar", "table", "kits", "metrics", "analytics"];
      if (allowedViews.includes(viewParam)) {
        onTabChange(viewParam === "analytics" ? "metrics" : viewParam);
        setDeepLinkHandled(true);
        return;
      }
    }

    if (requestIdParam && sampleOrders.length) {
      const req = sampleOrders.find((r) => r.id === requestIdParam);
      if (req) {
        onRequestSelect(req);
        onTabChange("create");
        window.scrollTo({ top: 0, behavior: "smooth" });
        setDeepLinkHandled(true);
        return;
      }
    }

    if (accountIdParam) {
      const account = accounts.find((a) => a.id === accountIdParam);
      if (account) {
        onAccountSelect(account);
        onTabChange("create");
        window.scrollTo({ top: 0, behavior: "smooth" });
        setDeepLinkHandled(true);
        return;
      }
    }
  }, [
    location.search,
    loading,
    sampleOrders,
    accounts,
    deepLinkHandled,
    onRequestSelect,
    onAccountSelect,
    onTabChange,
  ]);

  return { deepLinkHandled };
};
